import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "book-cover" }

import { computed } from 'vue'

import { Doc, DocCoverProps } from '@/models/interfaces'
import { cacheBust as addCacheBust } from '@/models/doc'

import BookFallbackCover from './BookFallbackCover.vue'
import { IS_PRERENDERING } from '@/init/settings'
import LazyImage from '@/app/components/podcast/card/LazyImage.vue'
import PublicImage from '@/app/components/podcast/card/PublicImage.vue'
import { useFallbackCover_13860 } from '@/services/ab'
import { isContentTranslated } from '@/services/weglot'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookCover',
  props: {
    doc: {},
    coverClass: {},
    fallbackCoverClass: {},
    cacheBust: { type: Boolean },
    sizes: {},
    srcset: {}
  },
  setup(__props: any) {

const props = __props

const useFallbackCover = computed(() => {
  return isContentTranslated() || useFallbackCover_13860(props.doc as Doc)
})

const humanCoverClass = computed(() => {
  const classes = [props.coverClass]

  if (IS_PRERENDERING) {
    // We don't check for is_first_doc on public pages
    return classes
  }

  // Add hide_cover_13860 if we variant B will be applied
  if (useFallbackCover.value) {
    classes.push('hide_cover_13860')
  }

  return classes
})

const fallbackClass = computed(() => {
  const classes = [props.fallbackCoverClass]

  // Always show fallback if we don't have a cover_image
  if (!props.doc.cover_image) {
    return classes
  }

  // Hide fallback cover during prerendering or if we want to show the human cover.
  if (IS_PRERENDERING || !useFallbackCover.value) {
    classes.push('hide_cover_13860')
    return classes
  }

  // Otherwise, do not hide the fallback cover (human cover should be hidden
  // at the same time by the logic in the `humanCoverClass` property)
  return classes
})

const coverUrl = computed(() => {
  if (!props.doc.cover_image) {
    return
  }

  if (props.cacheBust) {
    return addCacheBust(props.doc.cover_image)
  }

  return props.doc.cover_image
})

const lazyComponent = computed(() => {
  return !IS_PRERENDERING ? LazyImage : PublicImage
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.doc.cover_image)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(lazyComponent.value), {
          key: 0,
          src: coverUrl.value,
          crossorigin: "anonymous",
          class: _normalizeClass(["book-cover__image", humanCoverClass.value]),
          sizes: __props.sizes,
          srcset: __props.srcset,
          alt: ""
        }, null, 8, ["src", "class", "sizes", "srcset"]))
      : _createCommentVNode("", true),
    _createVNode(BookFallbackCover, {
      title: __props.doc.title,
      subtitle: __props.doc.author,
      class: _normalizeClass(fallbackClass.value)
    }, null, 8, ["title", "subtitle", "class"])
  ]))
}
}

})